import { MediaItem, StreamingMediaSource } from '../models';
import { MediaControllerState } from './enums';

export class MediaControllerStateSnapshot {

    state: MediaControllerState;

    playlist: MediaItem[];
    currentItem: MediaItem;
    currentSource: StreamingMediaSource;

    containerId: string;
    timestamp: number;
    position: number;
    duration: number;

    muted: boolean;
    visible: boolean;
    autoplayEnabled: boolean;

    constructor() {
    }
}
